module.exports = __webpack_public_path__ + "img/image2.1b17cad9.svg";